import React from 'react';
import { connect } from 'react-redux';
import Slider from 'react-slick';

import { changeActiveNews } from './newsDucks';

class NewsPanel extends React.Component {

  constructor(props) {
    super(props);
    if (props.news && props.news.length > 0) {
      this.state = {
        activeIndex: 0,
      };
    } else {
      this.state = {
        activeIndex: -1,
      };
    }
  }

  onBeforeChange = (oldIndex, newIndex) => {
    this.setState({
      activeIndex: newIndex,
    });
    this.props.changeActiveNews(newIndex);
  };

  getSettings = () => {
    const { news, duration } = this.props;
    const { activeIndex } = this.state;
    // noinspection JSUnusedGlobalSymbols
    return {
      afterChange: this.onAfterChange,
      arrows: false,
      beforeChange: this.onBeforeChange,
      dots: news.length > 1,
      autoplay: news.length > 1,
      autoplaySpeed: duration,
      customPaging: i => (
        <button
          className={i === activeIndex ? 'news-active-chip' : 'news-inactive-chip'}
        >
          {i + 1}
        </button>
      ),
    };
  };

  render() {
    const { news } = this.props;
    if (news.length === 0) {
      return null;
    }
    /* eslint-disable react/no-danger */
    return (
      <div className="carrousel" id="caroussel" style={{ backgroundColor: this.props.color }}>
        <Slider {...this.getSettings()}>
          {
            news.map((newsEntry, index) => (
              <div
                data-index={index}
                dangerouslySetInnerHTML={{ __html: newsEntry.content }}
                key={index}
              />
            ))
          }
        </Slider>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  news: state.news.data,
  color: state.news.color,
  duration: state.news.duration,
});

const mapDispatchToProps = {
  changeActiveNews,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewsPanel);



// WEBPACK FOOTER //
// ./book/src/news/NewsPanel.jsx